import { render, staticRenderFns } from "./BulkProjectRelatedPlushies.vue?vue&type=template&id=39ae8eb3&scoped=true&"
import script from "./BulkProjectRelatedPlushies.vue?vue&type=script&lang=ts&"
export * from "./BulkProjectRelatedPlushies.vue?vue&type=script&lang=ts&"
import style0 from "./BulkProjectRelatedPlushies.vue?vue&type=style&index=0&id=39ae8eb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ae8eb3",
  null
  
)

export default component.exports